import { LoginOutlined, SettingOutlined } from '@ant-design/icons';
import { Divider, Drawer } from 'antd';
import { Fragment, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import LogoImg from "../../assets/images/NFA.svg";
import Person from "../../assets/images/person.svg";
// import Avatar from '../../assets/images/avatar.png'
import AuthModal from '../../components/Modal/AuthModal';
import { closeLoginModalFunc, closeSignupModalFunc, showLoginModalFunc, showSignupModalFunc } from '../../redux/Modal/modal.actions';
import { logOut } from '../../redux/User/user.actions';
import LogInForm from "../Auth/LoginForm";
import SignUpForm from '../Auth/SignUpForm';
import {
  DrawerTabWrapper, HeaderWrapper,
  LogINButton,
  Logo,
  LogoWrapper,
  NavLinksWrap,
  SignUpButton,
  UserPhoto,
  UserPhotoWrap
} from "./style";




function Header(props) {
  const { showLoginModalFunc, showSignup, showLogin, showSignupModalFunc, closeLoginModalFunc, closeSignupModalFunc, logOut } = props;

  const [visible, setVisible] = useState(false);
  const currentUser = useSelector(({ User }) => User.currentUser);
  const handleLogOut = async () => {
    await logOut()
    setVisible(false);
  }

  return (
    <HeaderWrapper>
      {/* Logo */}
      <LogoWrapper>
        <Logo src={LogoImg} alt="logo" />
      </LogoWrapper>
      {/* End of Logo */}

      {/* Nav Links */}
      <NavLinksWrap>
        <NavLink className="header_nav" to="/">
          {" "}
          Blog
        </NavLink>
        <NavLink className="header_nav" to="/create-event">
          {" "}
          Host An Experience{" "}
        </NavLink>
        {currentUser ? (
          <Fragment>
            <UserPhotoWrap onClick={() => setVisible(true)}>
              <UserPhoto
                src={currentUser.photoUrl ? currentUser.photoUrl : Person}
              />
            </UserPhotoWrap>
          </Fragment>
        ) : (
          <Fragment>
            <SignUpButton onClick={() => showSignupModalFunc()}> Sign Up</SignUpButton>
            <LogINButton onClick={() => showLoginModalFunc()}>Log in</LogINButton>
          </Fragment>
        )}
      </NavLinksWrap>
      {/* End of Nav Links */}

      {/* sign up modal */}
      <AuthModal open={showSignup} hide={closeSignupModalFunc}>
        <SignUpForm />
      </AuthModal>

      <AuthModal open={showLogin} hide={closeLoginModalFunc}>
        <LogInForm hideFunc={showLoginModalFunc} />
      </AuthModal>

      {/* Drawer */}

      <Drawer
        // title={`Hi ${currentUser.hostelName}`}
        placement="right"
        closable={false}
        onClose={() => setVisible(false)}
        visible={visible}
        drawerStyle={{
          background: '#F4F4F4'
        }}
      >
        <DrawerTabWrapper className="drawerTabWrapper">
          <UserPhotoWrap style={{ marginBottom: "10px" }} onClick={() => setVisible(true)}>
            <UserPhoto
              src={currentUser && currentUser.photoUrl ? currentUser.photoUrl : Person}
            />
          </UserPhotoWrap>
          <h4>{currentUser && currentUser.hostelName}</h4>
          <h4 style={{ margin: "10px 0xp" }}>{currentUser && currentUser.email}</h4>
          <Divider />

          <ul>
            <li>Profile</li>
            <Link className="drawerLink" to="/your-experiences">
              <li>
                Your Experiences
              </li>
            </Link >
            <Link to="create-event" className="drawerLink">
              <li>Create Experience</li>
            </Link>
            <Divider />
            <li> <SettingOutlined />Settings</li>

            <li className="logOutBtn" onClick={handleLogOut}> <LoginOutlined /> Log out</li>

          </ul>

        </DrawerTabWrapper>

      </Drawer>



    </HeaderWrapper>
  );
}
const mapStateToProps = ({ Modal }) => ({
  showLogin: Modal.showLogin,
  showSignup: Modal.showSignup
});
const mapDispatchToProps = {
  showLoginModalFunc,
  showSignupModalFunc,
  closeLoginModalFunc,
  closeSignupModalFunc,
  logOut
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);
